/**
 * Helpers for the shell's canonical `agent` query param, which opens the
 * shell-hosted Robin Assistant sidebar (see `apps/shell/.../AgentChatSidebar`).
 * Held in the URL (like the composer's `event` param) so a refresh restores
 * the open panel.
 *
 * Only the shell writes this param; MFEs read it (through these helpers) to
 * derive the single right-hand sider policy — the assistant panel occupies
 * the same right-hand slot as the shell event composer and the MFE detail
 * siders (see `types/siderChannel.ts` and `shellSiderVisibility.ts`).
 */
export var SHELL_AGENT_PARAM = 'agent';
var AGENT_CHAT_OPEN_VALUE = 'open';
/**
 * Whether the assistant panel is open, from a location search string (e.g.
 * `useLocation().search`). Note this is the PARAM state, not visibility: the
 * shell composer covers an open assistant while the `event` param is present
 * — use `isShellRightSiderVisible` when visibility is what matters.
 */
export var isAgentChatOpen = function (search) {
    return new URLSearchParams(search).get(SHELL_AGENT_PARAM) === AGENT_CHAT_OPEN_VALUE;
};
/**
 * Write the open-assistant param into a URL being built elsewhere (e.g. an
 * agent event deep link). Kept here so the open value stays private and every
 * writer and reader of the param goes through this module.
 */
export var applyAgentChatParam = function (params) {
    params.set(SHELL_AGENT_PARAM, AGENT_CHAT_OPEN_VALUE);
};
